<template>
  <div id="assigningPlots">
    <v-card
      class="mx-auto"
      max-width="600"
      min-width="300"
      min-height="80"
      color="#f6f6fa"
    >
    <p style="color:#FFFFFF;background-color:#5555BB"><b>陰謀カードの配布</b></p>
    <div class="assign-plot-area">
      <div v-if="isLeader">
          <div class="assigning-table">
            <v-simple-table class="mt-4">
              <template v-slot:default>
                <tbody>
                  <tr v-for="(plot, key) in drawnPlots" v-bind:key="plot.id">
                    <td style="width:180px"><span v-on:click="showEffect(plot.id)" class="plot-name"><b><u>{{plot.name}}</u></b></span></td>
                    <td style="width:10px">→</td>
                    <td style="width:150px">
                      <v-btn v-if="key==selectedPlotIndex" v-on:click="selectPlot(key)" class="white--text" tile color="#6060E0" min-width="160" style="text-transform: none;font-size:16px">
                        <b>{{assignedUsers[key].name}}</b>
                      </v-btn>
                      <v-btn v-else v-on:click="selectPlot(key)" color="#6060E0" outlined tile text elevation=1 min-width="160" style="text-transform: none;font-size:16px; background-color:#FFF">{{assignedUsers[key].name}}</v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>

          <div style="margin: auto 0;">
            <v-container fluid class="mt-n2">
              <v-expand-transition>
                <v-card
                  v-show="selectedPlotIndex>-1"
                  elevation=0
                  class="my-2"
                  color="#F6F6FA"
                >
                  <v-row class="mx-auto">
                    <v-col class="my-n2" v-for="(user, key) in users.filter(user => user.id != userId)" v-bind:key="user.name" >
                      <v-card class="" elevation=0 max-width=240 min-width=240>
                        <div style="text-align:left;">
                          <v-simple-table dense >
                            <td style="width:90px;">
                              <div class="assign-button background-color">
                                <pickButton v-if="isAssigned[selectedPlotIndex][key]" v-on:pushed="assign(key)" activeLabel="選択" inactiveLabel="未選択" active="true" />
                                <pickButton v-else v-on:pushed="assign(key)" activeLabel="選択" inactiveLabel="未選択" active="false" />
                              </div>
                            </td>
                            <td style="padding-left:12px;width:140px">
                              <span class="user-label">{{ user.name }}</span>
                            </td>
                          </v-simple-table>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </v-expand-transition>
            </v-container>
          </div>
          <div class="send-button">
            <sendButton v-if="isFinished" v-on:pushed="push" label="配布" active="true"/>
            <sendButton v-else label="配布" active="false"/>
          </div>

      </div>
      <div v-else>
        <p>リーダー({{leader.name}})が
        <span v-for="(plot,key) in drawnPlots" v-bind:key="plot.id"><span v-if="key!=0">, </span> <span v-on:click="showEffect(plot.id)" class="plot-name"><b><u>{{plot.name}}</u></b> </span></span>
        の配布先を<span style="display: inline-block;">選択しています．</span></p>
      </div>
    </div>
  </v-card>
  </div>
</template>

<script>
import pickButton from '@/components/gameUiComponents/PickedButton.vue'
import sendButton from '@/components/gameUiComponents/SendButton.vue'
export default {
  name: "assigningPlots",
  plops: [],
  components: {
    pickButton,
    sendButton
  },
  data() {
    return {
      plotEffect: "",
      target: null,
      roomId: this.$store.state.gameInfo.roomId,
      userId: this.$store.state.userInfo.id,
      leader: this.$store.getters.leader,
      socket: this.$store.state.webSocket.socket,
      selectedPlotIndex: 0,
      isAssigned: [],
      assignedUsers : [],
    };
  },
  computed: {
    users: function() {
      return this.$store.state.userList.users;
    },
    round () {
      return this.$store.state.missionInfo.round
    },
    isLeader: function() {
      // return true
      return this.$store.getters.isLeader;
    },
    isAssign : function(num) {
      return this.isAssigned[num]
    },
    drawnPlots : function() {
      return this.$store.getters.getDrawnPlots(this.$store.state.missionInfo.round)
    },
    plotNames : function() {
      var names = []
      for (var i in this.drawnPlots){
        names.push(this.drawnPlots[i].name)
      }
      return names
    },
    isFinished: function() {
      return ((this.drawnPlots.length==1 && this.isAssigned[0].indexOf(true)>=0)||(this.drawnPlots.length==2 && this.isAssigned[0].indexOf(true)>=0 && this.isAssigned[1].indexOf(true)>=0) )
    },
  },
  methods: {
    selectPlot(idx){
      this.selectedPlotIndex = idx
    },
    assign(num) {
      if (this.isAssigned[this.selectedPlotIndex][num]){
        this.$set(this.assignedUsers, this.selectedPlotIndex, {name:"未選択"})
        this.$set(this.isAssigned[this.selectedPlotIndex], num, false)
      }else {
        // すでにそのプレイヤにアサインされていたら，アサインできない
        for (var i=0; i<this.isAssigned; i++){
          if (this.isAssigned[i][num]){
            var modalContent = {title: "陰謀カード配布時のルール", text: "同じプレイヤーに複数配ることはできません．"}
            this.$emit('send-modal', modalContent)
            return;
          }
        }
        for (i=0; i<this.users.length; i++){
          this.$set(this.isAssigned[this.selectedPlotIndex], i, false)
        }
        this.$set(this.assignedUsers, this.selectedPlotIndex, this.users.filter(user => user.id!=this.userId)[num])
        this.$set(this.isAssigned[this.selectedPlotIndex], num, true)
      }
    },
    showEffect: function(id){
      var plot = this.$store.getters.getPlotEffect(id);
      var modalContent = {title: plot.name, text: plot.effect}
      this.$emit('send-modal', modalContent)
    },
    push(){
      var _assign = []
      for (var i in this.drawnPlots){
        _assign.push({"plotId": this.drawnPlots[i].id, "userId": String(this.assignedUsers[i].id)})
      }
      this.$emit("send-request", {"action": "assign-plots", "roomId": this.roomId, "userId": this.userId, data: {"assign": _assign}})
    }

  },
  created() {
    for (var i=0; i<this.drawnPlots.length; i++){
      var assigned = []
      for (var j=0; j<this.users.filter(user => user.id!=this.userId).length; j++){
        assigned.push(false)
      }
      this.isAssigned.push(assigned)
      this.assignedUsers.push({name: "未選択"})
    }

    var self = this
    this.socket.onmessage = function(event){
      console.log("Received")
      console.log(event)
      const res = JSON.parse(event.data)
      if (!res.state) {return}

      var snackText = ""
      var assigned = res.data.assigned
      if (self.drawnPlots.length > assigned.length ){
        snackText = "責任者は使用できないため破棄されました．"
        self.$emit("show-text", {state: "assigning-plots-responsibility-discarded", text: snackText})
      }
      // アサインするカードがあるなら
      if (assigned.length > 0){
        self.$store.commit('setPlots', res.data.assigned)
        snackText = ""
        for (var i=0; i<assigned.length; i++){
          if (i > 0){
            snackText += "，"
          }
          snackText += self.$store.getters.getPlotName(assigned[i].plotId)
          snackText += "が"
          snackText += self.$store.getters.getUserById(assigned[i].userId).name
          snackText += "に"
        }
        snackText += "渡されました．"
        self.$emit("show-text", {state: "assigning-plots", text: snackText})
      }

      var nextState = "wait-immediate-effect"
      if (res.state == "wait-immediate-effect"){
        nextState = "waitImmediateEffect"
      }else if (res.state == "assigning-mission"){
        nextState = "assigningMission"
      }
      self.$emit("proceed-state", nextState)
    }

  }
};
</script>

<style>
#assigningPlots {
  /* background-color: rgb(152, 250, 157); */
}
#assigningPlots .assign-plot-area{
  align-items: center;
  display: inline-block;
  text-align:center;
}
#assigningPlots .send-button {
  padding-bottom: 12px;
}
#assigningPlots .assigning-table {
 align-items: left;
 display: inline-block;
 text-align:center;
 margin-top: -12px;
}
#assigningPlots td {
  font-size: 16px;
  border-bottom-width: 0px;
  background-color: #F6F6FA;
}
#assigningPlots .assign-button {
  margin-top: 4px;
  margin-bottom: 4px;
  background-color: #FFFFFF
}
#assigningPlots .background-color {
  background-color: #F6F6FA;
}
#assigningPlots .plot-name {
  color: #5555BB;
  cursor:pointer;
  display: inline-block;
}
</style>
